<template>
  <div style="flex: 1; display: flex; flex-direction: column; min-height: 0">
    <div v-if="!cfg" class="mono" style="flex: 1; display: flex; align-items: center; justify-content: center; color: var(--hsl-40)">
      {{ error || "Loading…" }}
    </div>
    <template v-else>
      <div style="flex: 1; overflow: auto; min-height: 0; padding: 16px 20px 20px">
        <div horizontal align-center style="gap: 8px; margin-bottom: 11px">
          <span class="micro">Metadata set</span>
          <span style="flex: 1; height: 1px; background: var(--border)"></span>
        </div>
        <select v-model="cfg.metadataSetId" class="mv-input" style="width: 332px" @change="cfg.requiredFieldIds = []">
          <option :value="null">No metadata — upload asks for nothing</option>
          <option v-for="s in $store.state.metadataSets" :key="s.id" :value="s.id">{{ s.label || "Untitled" }}</option>
        </select>

        <div horizontal align-center style="gap: 8px; margin: 22px 0 11px">
          <span class="micro">Fields</span>
          <span style="flex: 1; height: 1px; background: var(--border)"></span>
          <span class="mono" style="font-size: 10px; color: var(--hsl-46)">{{ cfg.requiredFieldIds.length }} required</span>
        </div>
        <div style="display: flex; flex-direction: column; gap: 9px">
          <div
            v-for="f in fields"
            :key="f.id"
            horizontal
            align-center
            nowrap
            style="gap: 9px; background: var(--back-header); border: 1px solid var(--border); border-radius: 9px; padding: 9px 12px">
            <span nowrap style="flex: 1; font-size: 12.5px; font-weight: 600; overflow: hidden; text-overflow: ellipsis">{{
              f.label || "Untitled"
            }}</span>
            <span class="type-tag">{{ f.type }}</span>
            <label
              style="display: inline-flex; align-items: center; gap: 6px; flex: none; white-space: nowrap; cursor: pointer; font-size: 11.5px; color: var(--hsl-66)">
              <input type="checkbox" :checked="isRequired(f)" @change="toggleRequired(f)" />
              required
            </label>
          </div>
          <div v-if="!fields.length" class="mono" style="padding: 30px; text-align: center; color: var(--hsl-40)">
            {{ cfg.metadataSetId ? "This set has no fields yet." : "No set chosen — the upload dialog asks for a file only." }}
          </div>
        </div>
      </div>

      <div footer style="height: 46px; min-height: 46px; max-height: 46px; gap: 10px">
        <span class="mono" style="font-size: 10px" :style="{ color: error ? 'var(--error)' : 'var(--hsl-46)' }">{{
          error || "Applies to the next upload — no restart needed"
        }}</span>
        <div style="margin-left: auto; display: flex; gap: 8px">
          <v-btn small :disabled="saving" @click="load()">Reset</v-btn>
          <v-btn small class="addbtn" :disabled="saving" @click="save()">{{ saving ? "Saving…" : "Save" }}</v-btn>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { endpointMessage } from "@/scripts/apiErrors.js";

export default {
  data() {
    return { cfg: null, saving: false, error: "" };
  },
  computed: {
    fields() {
      const set = this.$store.state.metadataSets.find((s) => s.id === this.cfg.metadataSetId);
      return (set && set.metadata) || [];
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.error = "";
      this.$store.state.loadUploadConfig((error, data) => {
        if (error) this.error = endpointMessage(error);
        else this.show(data);
      });
    },
    show(config) {
      this.cfg = JSON.parse(JSON.stringify(config));
      if (!this.cfg.metadataSetId) this.cfg.metadataSetId = null;
      if (!this.cfg.requiredFieldIds) this.cfg.requiredFieldIds = [];
    },
    isRequired(field) {
      return this.cfg.requiredFieldIds.indexOf(field.id) !== -1;
    },
    toggleRequired(field) {
      const at = this.cfg.requiredFieldIds.indexOf(field.id);
      if (at === -1) this.cfg.requiredFieldIds.push(field.id);
      else this.cfg.requiredFieldIds.splice(at, 1);
    },
    save() {
      this.saving = true;
      this.error = "";
      this.$store.state.saveUploadConfig(this.cfg, (error, data) => {
        this.saving = false;
        if (error) this.error = endpointMessage(error);
        else this.show(data);
      });
    },
  },
};
</script>
